import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Activity, ShoppingCart, Users, Link as LinkIcon, Clock } from 'lucide-react';
import { Table, Tag, Badge, Spin } from 'antd';
import api from '../api/client';
import dayjs from 'dayjs';

export default function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEvents();
    // Optional: Poll for updates every 10s
    const interval = setInterval(fetchEvents, 10000);
    return () => clearInterval(interval);
  }, []);

  const fetchEvents = async () => {
    try {
      const res = await api.get('/analytics/events');
      setEvents(res.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Тип события',
      dataIndex: 'event_type',
      key: 'type',
      render: (type) => {
        let icon = <Activity size={16} />;
        let text = type;
        let iconClass = 'text-slate-400';

        if (type === 'channel_join') {
          icon = <Users size={16} />;
          text = 'Вступление в канал';
          iconClass = 'text-blue-400';
        } else if (type === 'channel_leave') {
          icon = <Users size={16} />;
          text = 'Выход из канала';
          iconClass = 'text-rose-400';
        } else if (type === 'purchase') {
          icon = <ShoppingCart size={16} />;
          text = 'Покупка';
          iconClass = 'text-emerald-400';
        } else if (type === 'referral_click') {
          icon = <LinkIcon size={16} />;
          text = 'Переход по ссылке';
          iconClass = 'text-purple-400';
        }

        return (
          <div className="flex items-center gap-2">
            <span className={iconClass}>{icon}</span>
            <span className="text-white">{text}</span>
          </div>
        );
      }
    },
    {
      title: 'Пользователь',
      dataIndex: 'custom_attributes',
      key: 'user',
      render: (attrs, record) => (
        <span className="text-slate-300">
          {attrs?.username ? `@${attrs.username}` : attrs?.first_name || `User #${record.journey_id}`}
        </span>
      )
    },
    {
      title: 'Детали',
      dataIndex: 'event_data',
      key: 'data',
      render: (data) => (
        <code className="text-xs bg-black/20 p-1 rounded text-slate-400">
          {JSON.stringify(data).slice(0, 50)}{JSON.stringify(data).length > 50 ? '...' : ''}
        </code>
      )
    },
    {
      title: 'Время',
      dataIndex: 'created_at',
      key: 'time',
      render: (date) => (
        <div className="flex items-center gap-2 text-slate-400">
          <Clock size={14} />
          {dayjs(date).format('HH:mm:ss DD.MM')}
        </div>
      )
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-white mb-2">Лента событий</h1>
          <p className="text-slate-400">Живой поток действий пользователей в реальном времени</p>
        </div>
        <Badge status="processing" text={<span className="text-emerald-400">Live</span>} />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-surface rounded-xl border border-white/5 overflow-hidden"
      >
        <Table
          dataSource={events}
          columns={columns}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 20 }}
          className="custom-table"
        />
      </motion.div>
    </div>
  );
}
